import React from 'react';
import { useQuery } from '@apollo/client';
import { Button } from 'semantic-ui-react';
import InviteExpertModal from '../InviteModal/InviteExpertModal';
import { MANAGED_PROJECTS } from '../../queries/profile';

const RequestButton = ({ expert }) => {
  const { loading, data } = useQuery(MANAGED_PROJECTS);
  const managedProjects = data?.me?.managedProjects ?? [];

  const numJobsInvited = managedProjects.filter(
    (p) => p.status !== 'Completed' && p.jobs.some((j) => j.user.id === expert.id),
  );

  return (
    <InviteExpertModal expert={expert}>
      <Button
        fluid
        loading={loading}
        className={numJobsInvited.length > 0 ? 'primary-btn' : 'basic-btn'}
      >
        {numJobsInvited.length > 0 ? `Invited to ${numJobsInvited.length} project(s)` : 'Invite to project'}
      </Button>
    </InviteExpertModal>
  );
};

export default RequestButton;
